var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.292.253l1.391 1.543 3.462 3.84.696.771L18.45 7.95l-.696-.771-2.479-2.75v15.425h-1.967V4.428l-2.479 2.75-.695.772-1.391-1.543.695-.771 4.158-4.612.696-.771zm-7.6-.107v15.48l2.479-2.75.695-.771 1.391 1.543-.695.77-3.463 3.84-1.39 1.544-.696-.772L.855 14.42l-.696-.771 1.391-1.543.696.771 2.478 2.749V.145h1.968z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.779f758d352e08caa08b6b01387a5916.svg";
export { ForwardRef as ReactComponent };